module.exports = __webpack_public_path__ + "img/lotteryCond_icon.22fe53b3.png";